import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "sidebar" };
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { HomeFilled, Monitor, Connection, Collection, Cpu, Clock, Select, Setting, User, Document, DataAnalysis, Warning } from '@element-plus/icons-vue';
import { useUserStore } from '@/stores/user';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Sidebar',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const userStore = useUserStore();
        const activeMenu = computed(() => {
            // 优先使用路由元信息中的 activeMenu，用于详情页高亮父级菜单
            const metaActive = route.meta && route.meta.activeMenu;
            return metaActive || route.path;
        });
        // 允许点击当前激活项：如果点击的就是当前路由，则带上时间戳参数重新导航，触发刷新
        function handleSelect(index) {
            const currentActive = activeMenu.value;
            if (index === currentActive || index === route.path) {
                // 重新导航到相同路径，附加刷新参数
                router.push({ path: index, query: { r: Date.now().toString() } });
            }
            // 其他情况交给 el-menu 的 router 行为处理
        }
        return (_ctx, _cache) => {
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_menu_item = _resolveComponent("el-menu-item");
            const _component_el_sub_menu = _resolveComponent("el-sub-menu");
            const _component_el_menu = _resolveComponent("el-menu");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "logo" }, [
                    _createElementVNode("h2", null, "智慧运维云平台")
                ], -1)),
                _createVNode(_component_el_menu, {
                    "default-active": activeMenu.value,
                    class: "sidebar-menu",
                    "background-color": "#304156",
                    "text-color": "#bfcbd9",
                    "active-text-color": "#409EFF",
                    router: "",
                    onSelect: handleSelect
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, { index: "/dashboard" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(HomeFilled))
                                    ]),
                                    _: 1
                                }),
                                _cache[0] || (_cache[0] = _createElementVNode("span", null, "仪表盘", -1))
                            ]),
                            _: 1,
                            __: [0]
                        }),
                        (_unref(userStore).isAdmin || _unref(userStore).hasGroupManagementPermission)
                            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                key: 0,
                                index: "/client-management"
                            }, {
                                title: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Monitor))
                                        ]),
                                        _: 1
                                    }),
                                    _cache[1] || (_cache[1] = _createElementVNode("span", null, "客户管理", -1))
                                ]),
                                default: _withCtx(() => [
                                    (_unref(userStore).isAdmin || _unref(userStore).hasGroupManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 0,
                                            index: "/clients"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Monitor))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[2] || (_cache[2] = _createElementVNode("span", null, "客户端列表", -1))
                                            ]),
                                            _: 1,
                                            __: [2]
                                        }))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_el_menu_item, { index: "/tunnels" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Connection))
                                                ]),
                                                _: 1
                                            }),
                                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "隧道管理", -1))
                                        ]),
                                        _: 1,
                                        __: [3]
                                    }),
                                    (_unref(userStore).isAdmin || _unref(userStore).hasGroupManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 1,
                                            index: "/health/groups"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Collection))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[4] || (_cache[4] = _createElementVNode("span", null, "组管理", -1))
                                            ]),
                                            _: 1,
                                            __: [4]
                                        }))
                                        : _createCommentVNode("", true),
                                    (_unref(userStore).isAdmin || _unref(userStore).hasGroupManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 2,
                                            index: "/clients/incidents"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Document))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[5] || (_cache[5] = _createElementVNode("span", null, "报障列表", -1))
                                            ]),
                                            _: 1,
                                            __: [5]
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_unref(userStore).isAdmin || _unref(userStore).hasDeviceManagementPermission)
                            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                key: 1,
                                index: "/devices"
                            }, {
                                title: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Cpu))
                                        ]),
                                        _: 1
                                    }),
                                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "设备管理", -1))
                                ]),
                                default: _withCtx(() => [
                                    (_unref(userStore).isAdmin || _unref(userStore).hasDeviceManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 0,
                                            index: "/devices/pending"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Clock))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[7] || (_cache[7] = _createElementVNode("span", null, "待审核设备", -1))
                                            ]),
                                            _: 1,
                                            __: [7]
                                        }))
                                        : _createCommentVNode("", true),
                                    (_unref(userStore).isAdmin || _unref(userStore).hasDeviceManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 1,
                                            index: "/devices/approved"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Select))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[8] || (_cache[8] = _createElementVNode("span", null, "已审核设备", -1))
                                            ]),
                                            _: 1,
                                            __: [8]
                                        }))
                                        : _createCommentVNode("", true),
                                    (_unref(userStore).isAdmin || _unref(userStore).hasDeviceManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 2,
                                            index: "/devices/statistics"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(DataAnalysis))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[9] || (_cache[9] = _createElementVNode("span", null, "有效期统计", -1))
                                            ]),
                                            _: 1,
                                            __: [9]
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_unref(userStore).isAdmin || _unref(userStore).hasSystemManagementPermission)
                            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                key: 2,
                                index: "/system"
                            }, {
                                title: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Setting))
                                        ]),
                                        _: 1
                                    }),
                                    _cache[10] || (_cache[10] = _createElementVNode("span", null, "系统管理", -1))
                                ]),
                                default: _withCtx(() => [
                                    (_unref(userStore).isAdmin || _unref(userStore).hasSystemManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 0,
                                            index: "/system/users"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(User))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[11] || (_cache[11] = _createElementVNode("span", null, "用户管理", -1))
                                            ]),
                                            _: 1,
                                            __: [11]
                                        }))
                                        : _createCommentVNode("", true),
                                    (_unref(userStore).isAdmin || _unref(userStore).hasSystemManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 1,
                                            index: "/system/group-types"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Collection))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[12] || (_cache[12] = _createElementVNode("span", null, "组类型管理", -1))
                                            ]),
                                            _: 1,
                                            __: [12]
                                        }))
                                        : _createCommentVNode("", true),
                                    (_unref(userStore).isAdmin || _unref(userStore).hasSystemManagementPermission)
                                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: 2,
                                            index: "/system/logs"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Document))
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[13] || (_cache[13] = _createElementVNode("span", null, "日志管理", -1))
                                            ]),
                                            _: 1,
                                            __: [13]
                                        }))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_el_menu_item, { index: "/health/alerts" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Warning))
                                                ]),
                                                _: 1
                                            }),
                                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "健康告警", -1))
                                        ]),
                                        _: 1,
                                        __: [14]
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["default-active"])
            ]));
        };
    }
});
